import { lazy, Suspense } from "react";

const Newsletter = lazy(() => import("./newsletter"));

export function LazyNewsletter() {
  return (
    <Suspense>
      <Newsletter />
    </Suspense>
  );
}
